import axios from "axios";
import { enqueue } from "./offlineQueue";
import { log } from "./logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("sohom_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

function parseRequestBody(data) {
  if (!data) return null;
  if (typeof data === "string") {
    try { return JSON.parse(data); } catch { return null; }
  }
  return data;
}

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("sohom_token");
      localStorage.removeItem("sohom_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
      return Promise.reject(err);
    }

    const cfg = err.config || {};
    const isNetwork = !err.response;
    const method = (cfg.method || "get").toLowerCase();
    const url = (cfg.url || "").replace(API_URL, "");
    const queueableMethods = ["post", "patch"];
    const queueablePaths = [/^\/leads$/, /^\/leads\/[^/]+$/, /^\/leads\/[^/]+\/follow-ups$/];

    if (isNetwork && queueableMethods.includes(method) && queueablePaths.some((r) => r.test(url))) {
      const body = parseRequestBody(cfg.data);
      try {
        log.info("[Sohom] Network offline — queueing", method.toUpperCase(), url);
        await enqueue({ url, method: method.toUpperCase(), body });
        return Promise.resolve({
          data: { _queued: true, _offline: true, ...(body || {}) },
          status: 202,
          statusText: "Queued (offline)",
          headers: {},
          config: cfg,
        });
      } catch (qErr) {
        log.error("[Sohom] Enqueue failed:", qErr);
      }
    }
    return Promise.reject(err);
  }
);

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_lead-ops-web/artifacts/25qby76e_SOHOM%20LOGO%20jpg.jpg";
